module.exports = __webpack_public_path__ + "static/media/imgSelfProductionBenefits2.1d1bc1d5.png";